module.exports = __webpack_public_path__ + "static/media/tests.87ef084d.png";